/**
 * lh-cart-accordions.js
 * Lolahome — Persiste o estado aberto/fechado dos acordeões do carrinho.
 *
 * Gerencia os acordeões <collapsible-section> (frete e cupom).
 * O gift-wrap tem gestão própria via lh-cart-gift-wrap.js.
 *
 * Estratégia:
 *  - Escuta cliques nos triggers via event delegation (sobrevive a re-renders)
 *  - Salva estado no localStorage após cada toggle
 *  - MutationObserver no #CartDrawer detecta re-renders e restaura o estado
 */

(function () {
  'use strict';

  const STORAGE_KEY = 'lh_accordions_state';

  // Acordeões gerenciados (identificados pelo aria-controls do trigger)
  const MANAGED = ['lh-accordion-shipping', 'lh-accordion-coupon'];

  // ─── Estado no localStorage ──────────────────────────────────────────────────
  function loadState() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {}; }
    catch { return {}; }
  }

  function saveState(id, open) {
    const state = loadState();
    state[id] = open;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  }

  // ─── DOM helpers ─────────────────────────────────────────────────────────────
  function getTrigger(id) {
    return document.querySelector('[aria-controls="' + id + '"]');
  }

  function isOpen(trigger) {
    return trigger.classList.contains('wt-collapse__trigger--active');
  }

  // ─── Restaura estado após re-render ──────────────────────────────────────────
  function restoreState() {
    // Move o widget do cupom antes de restaurar estados dos accordions,
    // para evitar que a manipulação do DOM resete os estados.
    placeCouponWidget();

    const state = loadState();
    MANAGED.forEach(function (id) {
      const trigger = getTrigger(id);
      if (!trigger) return;

      const shouldBeOpen = !!state[id];
      const currentlyOpen = isOpen(trigger);

      if (shouldBeOpen && !currentlyOpen) trigger.click();
      if (!shouldBeOpen && currentlyOpen) trigger.click();
    });
  }

  // ─── Coloca o widget de cupom do dCart dentro do accordion ──────────────────
  // O dCart injeta #scDiscountApp no header (seu fallback padrão).
  // Após re-render do drawer (carrinho ganha itens), movemos o container
  // persistente (.lh-coupon-persistent) para o accordion e colocamos o widget nele.
  // Remove duplicatas que o dCart pode ter criado.
  function placeCouponWidget() {
    var accordionSlot = document.querySelector('#lh-accordion-coupon .coupon-on-cart:not(.lh-coupon-persistent)');
    var persistent = document.querySelector('.coupon-on-cart.lh-coupon-persistent');

    // Substitui o container vazio do accordion pelo persistente
    if (accordionSlot && persistent && accordionSlot !== persistent) {
      accordionSlot.parentNode.replaceChild(persistent, accordionSlot);
    }

    var target = document.querySelector('#lh-accordion-coupon .coupon-on-cart');
    if (!target) return;

    // Move o primeiro widget encontrado para dentro do target (se ainda não está)
    if (!target.querySelector('#scDiscountApp')) {
      var widget = document.getElementById('scDiscountApp');
      if (widget) target.appendChild(widget);
    }

    // Remove duplicatas de #scDiscountApp (dCart pode recriar)
    var allWidgets = document.querySelectorAll('#scDiscountApp');
    var kept = target.querySelector('#scDiscountApp');
    allWidgets.forEach(function (w) { if (w !== kept) w.remove(); });
  }

  // ─── Event delegation: detecta toggle dos acordeões ─────────────────────────
  function attachListeners() {
    document.addEventListener('click', function (e) {
      const trigger = e.target.closest('.lh-cart-accordion__trigger');
      if (!trigger) return;
      const id = trigger.getAttribute('aria-controls');
      if (!MANAGED.includes(id)) return;

      // Lê o estado após o <collapsible-section> processar o clique
      setTimeout(function () {
        saveState(id, isOpen(trigger));
      }, 50);
    });
  }

  // ─── Observa re-renders do cart drawer ────────────────────────────────────────
  function observeCartDrawer() {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;

    new MutationObserver(function () {
      restoreState();
    }).observe(drawer, { childList: true, subtree: false });
  }

  // ─── Inicialização ────────────────────────────────────────────────────────────
  document.addEventListener('DOMContentLoaded', function () {
    attachListeners();
    restoreState();
    observeCartDrawer();
  });

})();